import React from 'react';
import SoArm101 from '../components/SoArm101';
import Builds from '../components/Builds';

export default function Work() {
  return (
    <>
      <SoArm101 />
      <Builds />
    </>
  );
}
